<template>
	<div>
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<el-form ref="classRecordPageInfoReq" :model="classRecordPageInfoReq" label-width="80px">
				<el-row>
					<el-col :span="3">
						<el-form-item label="学员姓名:">
							<el-input :clearable = true v-model="classRecordPageInfoReq.text" placeholder="请输姓名" />
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="手机号:">
							<el-input :clearable = true v-model="classRecordPageInfoReq.mobile" placeholder="请输入手机号" />
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<div class="block">
							<el-form-item label="日期:">
								<!-- <span class="demonstration">带快捷选项</span> -->
								<el-date-picker v-model="classRecordPageInfoReq.startDate" type="datetime"
									value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期">
								</el-date-picker>
								<el-date-picker v-model="classRecordPageInfoReq.endDate" type="datetime"
									value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束日期">
								</el-date-picker>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
				<el-row style="text-align: right;">
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="reGetclassRecordList()">查询
					</el-button>
				</el-row>
			</el-form>
			<!-- 学员签到记录区域 -->
			<el-table :data="classRecordList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index"></el-table-column>
				<el-table-column label="学员卡号" prop="studentId"></el-table-column>
				<el-table-column label="学员姓名" prop="name"></el-table-column>
				<el-table-column label="签到时间" prop="insertTime"></el-table-column>
				<el-table-column label="监管人手机号" prop="mobile"></el-table-column>
				<el-table-column label="监管人姓名" prop="parent"></el-table-column>
				<el-table-column label="性别" prop="gender">
					<template slot-scope="scope">
						{{ scope.row.gender == 1 ? '男' : (scope.row.gender == 2 ? '女' : '未知') }}
					</template>
				</el-table-column>
				<el-table-column label="年龄" prop="age"></el-table-column>
				<el-table-column label="班级" prop="classes">
					<template slot-scope="scope">
						{{ changeClassConfigValue(scope.row.classes,classesOptions) }}
					</template>
				</el-table-column>
				<el-table-column label="剩余课时" prop="classHour"></el-table-column>
				<el-table-column label="所属门店" prop="distributerName"></el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="classRecordPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="classRecordPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			classRecordPageInfoReq: {
				//当前页数
				page: 1,
				//当前每页多少条
				limit: 8,
				text: '',
				startDate: '',
				endDate: '',
				mobile: ''
			},
			classRecordList: [],
			total: 0,
			classesOptions: {}
		}
	},
	created() {
		this.getclassRecordList();
		this.getClassConfigList();
	},
	methods: {
		async getclassRecordList() {
			const {
				data: res
			} = await this.$http.post(
				'/classRecord/findAllRecord', this.classRecordPageInfoReq)
			console.log(res)
			if (res.code != 200) return this.$message.error(res.msg)
			this.classRecordList = res.data.list
			this.total = res.data.total
		},
		reGetclassRecordList() {
			if (this.classRecordPageInfoReq.startDate == null || this.classRecordPageInfoReq.endDate == null) {
				this.classRecordPageInfoReq.startDate = ''
				this.classRecordPageInfoReq.endDate = ''
			}
			this.classRecordPageInfoReq.page = 1;
			this.getclassRecordList();
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.classRecordPageInfoReq.limit = pageSize
			this.getclassRecordList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.classRecordPageInfoReq.page = pageNum
			this.getclassRecordList()
		},
		getClassConfigList(){
			this.$http.get('/classConfig/findAll').then(res => {
					if (res.data.code == 200) {
						console.log(res.data.data);
						this.classesOptions = res.data.data;
						return;
					}
					this.$message.error(res.data.msg)
				})
		},
		changeClassConfigValue(key,enums){
			console.log(key,enums);
			for(var i = 0;i<enums.length;i++){
				if(enums[i].classKey === key){
					return enums[i].classValue;
				}
			}
		}
	},
}
</script>

<style>
</style>